// extracted by mini-css-extract-plugin
export default {"shortTipsPc":"index_shortTipsPc_djuF-","fhxwkhdPc":"index_fhxwkhdPc_7lheR"};